export default "__VITE_ASSET__qTuB44aQ__"